import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { AbButton } from "abreact/misc/AbButton";
import { AbIcon } from "abreact/misc/AbIcon";
import * as React from "react";
export function AbToggleButton(props) {
  const classNames = ReactUtils.componentClassNamesString("ab-toggle-button", props, [props.value && "ab-toggled", !props.label && "ab-square-button"]);
  const icon = typeof props.icon === "string" ? /*#__PURE__*/React.createElement(AbIcon, {
    image: props.icon,
    size: props.size,
    className: ReactUtils.classNamesString(["ab-button-icon", props.value ? "ab-toggled" : undefined])
  }) : props.icon;
  return /*#__PURE__*/React.createElement(AbButton, _extends({}, props, {
    __htmlProps: {
      "aria-pressed": props.value,
      ...props.__htmlProps
    },
    className: classNames,
    icon: icon,
    onClick: () => props.onChange(!props.value)
  }));
}
//# sourceMappingURL=AbToggleButton.js.map
